"use client";

import React, { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-4">
        {[1, 2, 3].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-4">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-300 text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
function LocalTime() {
  const [time, setTime] = useState<string>("");
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    const updateTime = () => {
      const now = new Date();
      setTime(now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        timeZoneName: "short"
      }));
    };
    updateTime();
    const interval = setInterval(updateTime, 60000);
    return () => clearInterval(interval);
  }, []);
  if (!mounted) {
    return <span className="opacity-0">00:00 AM</span>;
  }
  return <span>{time}</span>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const socialLinks = [{
    name: "LinkedIn",
    url: "#"
  }, {
    name: "X (Twitter)",
    url: "#"
  }, {
    name: "Slack",
    url: "#"
  }];
  return <section data-section-id="204679" id="footer" className="dark bg-background text-foreground py-20 px-6 md:px-12 relative border-t border-border overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
        
        {}
        <div className="flex flex-col items-start justify-start">
          <Link to="/">
            <img src="https://boss-stallion-1.10web.cloud/wp-content/uploads/2026/04/oceanclaw_logo-1.png" alt="OceanClaw" className="h-3.5 object-contain" />
          </Link>
          <p className="mt-6 text-sm text-muted-foreground font-default leading-relaxed max-w-[200px]">
            Full-scale AI capability in under a minute.
          </p>
        </div>

        {}
        <div className="flex flex-col">
          <h4 className="font-default font-semibold text-foreground mb-6 tracking-widest uppercase text-xs">
            Product
          </h4>
          <MenuProvider menu_id="footer_menu">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="flex flex-col">
          <h4 className="font-default font-semibold text-foreground mb-6 tracking-widest uppercase text-xs">
            Company
          </h4>
          <ul className="flex flex-col gap-4">
            {socialLinks.map((social, i) => <li key={social.name} data-index={i}>
                <Link to={social.url} className="text-muted-foreground hover:text-primary transition-colors duration-300 text-sm font-default">
                  {social.name}
                </Link>
              </li>)}
          </ul>
        </div>

        {}
        <div className="flex flex-col justify-between">
          <div>
            <h4 className="font-default font-semibold text-foreground mb-6 tracking-widest uppercase text-xs">
              Service Status
            </h4>
            <div className="flex flex-col gap-2 text-sm text-muted-foreground font-default">
              <p>© {new Date().getFullYear()} OceanClaw.</p>
              <p>All rights reserved.</p>
              <p className="mt-4 flex items-center gap-2 text-primary font-medium tracking-wide uppercase text-[10px]">
                <span className="w-2 h-2 rounded-full bg-primary animate-pulse shadow-[0_0_8px_rgba(59,130,246,0.5)]" />
                Status: All Systems Operational
              </p>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 right-6 md:bottom-12 md:right-12">
        <Button variant="outline" size="icon" onClick={scrollToTop} className="rounded-full h-12 w-12 border-border bg-transparent text-muted-foreground hover:text-primary hover:border-primary/50 hover:bg-accent/10 transition-all duration-300 shadow-none" aria-label="Scroll to top">
          <ArrowUp className="size-5" />
        </Button>
      </div>
    </section>;
}